module.exports = __webpack_public_path__ + "small-right.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/small-right.svg?color1=%23333333&color2=
// module id = 2213
// module chunks = 67